export enum AuthorityResourceLimitationPeriods {
  RESOURCE_LIMITATION_PERIODS_VIEW = '1.1.6',
  RESOURCE_LIMITATION_PERIODS_ADD = '1.1.7',
  RESOURCE_LIMITATION_PERIODS_DELETE = '1.1.8',
}
